module.exports = __webpack_public_path__ + "static/media/jingteshu1.3f036de5.png";